<template>
  <div :style="{ height: gao + 'px', width: '100%' }">
    <hd></hd>
    <iframe :src="src" frameborder="0"></iframe>
  </div>
</template>
<script>
import hd from '@/components/header/index';
export default {
  components: { hd },
  data() {
    return {
      src: '',
      gao: document.documentElement.clientHeight,
    };
  },
  mounted() {
    console.log(this.$route);
    let data = this.$route.query;
    this.$axios.post('/api/transfer', data).then((res) => {
      console.log(res);
      if (res.data.code == 200) {
        this.src = res.data.data;
      }
    });
  },
};
</script>
<style>
iframe {
  width: 99.7%;
  min-width: 980px;
  margin-top: -5px;
  height: calc(100% - 50px);
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/view/user/transfer/index.vue